/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {listPublicArticles} from '../api'

export const useMutationListPublicArticles = createReactQueryMutationHook('listPublicArticles', listPublicArticles)
